import { DeleteAccountViewModel } from '@apis/model';
import { DeleteAccountResponse } from '@ul/api';

export const toDeleteAccountViewModel = (deleteAccountResponse: DeleteAccountResponse): DeleteAccountViewModel => {
    const { success, status } = deleteAccountResponse;
    return {
        success,
        status,
    };
};
